import 'nprogress/nprogress.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-perfect-scrollbar/dist/css/styles.css';
import App from './App';
import './index.css';
// Paleta y utilitarias globales de la capa @au (tokens.css + base.css). El barrel de
// @au/ui NO lo importa a propósito. dpg lo importa una vez por página porque carga cada
// mockup con lazy(); amaru2 no tiene ese patrón, así que acá va una sola vez.
import '@au/ui/amaru-ui.css';
import ReactGA from 'react-ga4';

const root = createRoot(document.getElementById('root')!);

//Initialize GA4
ReactGA.initialize('G-L26BDXFLXF');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
